import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import "./conf/";
import { Router} from 'react-router-dom';
import history from './history'
import * as serviceWorker from './serviceWorker';
import Routes from "./Routes";
import store from "./store";
import './utils/i18n';


ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Routes />
    </Router>
  </Provider>
  , document.getElementById('root'))

// expose store when run in Cypress
if (window.Cypress) {
  window.store = store
}
serviceWorker.unregister();
